import React, { useContext } from 'react';
import { store } from './reducer';
import Skeleton from '@material-ui/lab/Skeleton';
import List from '@material-ui/core/List';
import PaymentItem from './PaymentItem';
import Typography from '@material-ui/core/Typography';

const Customer = () => {
  const {
    state: { bidders, commissions, order },
  } = useContext(store);
  let total = 0;
  bidders?.forEach((b) => (total = total + b.propose * 1));
  commissions && (total = total + commissions * bidders.length);
  if (commissions && bidders && order)
    return (
      <div>
        <Typography component="h2" variant="h2">
          صاحب بار:
        </Typography>
        <List>
          <PaymentItem
            payment={total * 1}
            fullname={`${order?.customer?.firstName} ${order?.customer?.lastName}`}
            userId={order?.customer?._id}
            orderId={order?._id}
          />
        </List>
      </div>
    );
  else return <Skeleton variant="text" height={112} />;
};

export default React.memo(Customer);
